import vipService from '@api/vipConfig'
import service from '@api/config'

// 查询邀工币变动  type:类型 1-获取，2-使用
export const getCoin = (data) => {
  return vipService.request({
    url: `/activity/login/getCoin`,
    method: 'post',
    data: data
  })
}

// 推荐注册获取总数
export const getCoinSumByRecommend = (data) => {
  return vipService.request({
    url: `/coin/v4.3/getCoinSumByRecommend`,
    method: 'post',
    data: data
  })
}

// 推荐注册获取记录
export const getCoinListByRecommend = (data) => {
  return vipService.request({
    url: `/coin/v4.3/getCoinListByRecommend`,
    method: 'post',
    data: data
  })
}

// 获取用户加密手机号（用于分享）
export const getCryptoPhone = (data) => {
  return service.request({
    url: `/user/getCryptoPhone`,
    method: 'post',
    data: data
  })
}

//--------- 看视频获取万元金币---------

//  获取幸运号
export const getNum = (data) => {
  return vipService.request({
    url: `/learnsafevideo/get/num`,
    method: 'post',
    data: data
  })
}

// 获取活动参与信息
export const getInfo = (data) => {
  return vipService.request({
    url: `/learnsafevideo/info`,
    method: 'post',
    data: data
  })
}

//  我的幸运号  无参
export const luckynums = (data) => {
  return vipService.request({
    url: `/learnsafevideo/luckynums`,
    method: 'post',
    data: data
  })
}

// 我的金币
export const myWins = (data) => {
  return vipService.request({
    url: `/learnsafevideo/my/wins`,
    method: 'post',
    data: data
  })
}

// 获取im_id
export const getImId = (data) => {
  return service.request({
    url: `/data/customer/service/imid`,
    method: 'post',
    data: data
  })
}


